import axios from 'axios';
import { ISearchResult, ISearchPayload } from 'entities/Search/Search.models';

const basePath = 'search';

export const searchTransport = {
  get: (payload: ISearchPayload): Promise<ISearchResult> => axios.post(`${basePath}`, payload),
};
